<template>
  <div>
    <div class="background">
      <img src="../assets/images/login_bg.png" class="back_img">
    </div>
    <div class="login">
      <h1>
        用户注册
      </h1>
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row class="username">
          <el-col :span="24">
            <el-input
              class="class_account inputUserInfo"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              v-model="ruleForm.username" >
            </el-input>
          </el-col>
        </el-row>

        <el-row class="h20">
          <el-col :span="24">
            <el-input
              class="class_account inputUserInfo"
              placeholder="请输入密码(6-20位)"  prefix-icon="el-icon-lock" v-model="ruleForm.password" show-password></el-input>
          </el-col>
        </el-row>

        <el-row class="h20">
          <el-col :span="24">
            <el-input
              class="class_account inputUserInfo"
              placeholder="请再次输入密码"  prefix-icon="el-icon-lock" v-model="ruleForm.nextpassword" show-password></el-input>
          </el-col>
        </el-row>

        <el-row class="h7">
          <el-col :span="24">
            <el-link type="danger">{{ msg }}</el-link>
          </el-col>
        </el-row>
        <el-row class="h7">
          <el-col :span="24">
            <el-button type="primary" class="class_account logBtn" @click="submitForm('ruleForm')">注册账号</el-button>
          </el-col>
        </el-row>

      </el-form>

    </div>
  </div>
</template>

<script>
import { registerAddress } from '../request/api';

export default {
  name: 'LOGIN',
  data () {
    return {
      msg:"",
      ruleForm: {
        username: "",
        password: "",
        nextpassword: "",
        radio: "0"
      }

    }
  },
  methods: {
    validPassword(pwd) {
      let level = 1;
      if (pwd.length >= 8) {
        level += 5;
      }
      let m = [
        /[a-z]/,
        /[A-Z]/,
        /[\d]/,
        /[^\da-zA-Z]/
      ];
      for (let i = m.length - 1; i >= 0; i--) {
        if (null !== pwd.match(m[i])) {
          level += 1;
        }
      }
      return level;
    },
    submitForm() {
      if (this.ruleForm.username === '') {
        this.msg = "用户名不能为空";
        return false;
      }
      if (this.ruleForm.password === '') {
        this.msg = "密码不能为空";
        return false;
      }
      let level = this.validPassword(this.ruleForm.password);
      if (9 <= level) {
//这时是强密码了
      } else {
        this.msg = "密码不符合强校验规则，规则为：“长度大于等于8位，且包含大写字母、小写字母、特殊字符、阿拉伯数字四者中3种或以上”";
        return false;
      }
      if (this.ruleForm.nextpassword === '') {
        this.msg = "两次输入的密码不一致";
        return false;
      }
      if (this.ruleForm.password !== this.ruleForm.nextpassword) {
        this.msg = "两次输入的密码不一致";
        return false;
      }

      let param = {
        userName: this.ruleForm.username,
        password: this.ruleForm.password,
        userType: this.ruleForm.radio
      }
      // 提交注册请求
      registerAddress(param).then(
        resp => {
          if (resp.code === 1) {
            this.$message.success(resp.msg);
            this.msg = "注册成功";

            // 跳转到登录页面
            this.$router.push('/');
          } else {
            this.msg = resp.msg;
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  h1{
    font-size: 25px;
    margin-top: 50px;
  }
  .background {
    border-radius: 1px;
    width: 100%;
    height: 100%;
    z-index:-1;
    position: absolute;
  }
  .login{
    border-radius: 2px;
    width: 500px;
    height: 400px;
    background: white;
    z-index:1;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -200px;
    margin-left: -250px;
  }
  .back_img {
    width: 100%;
    height: 100%;
  }
  .class_account{
    width: 300px;
  }
  .username{
    margin-top: 50px;
  }
  .inputUserInfo .el-input__inner {
    border-radius: 50px;
  }

  .h7{
    margin-top: 7px;
  }
  .h15{
    margin-top: 15px;
  }
  .h20{
    margin-top: 20px;
  }
  .login .el-input {
    width: 300px
  }


</style>



// WEBPACK FOOTER //
// src/components/Register.vue